var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22496 11.625H3.77496C2.20829 11.625 1.01662 11.0583 0.424957 10.0333C-0.16671 9.00833 -0.0583765 7.69167 0.724957 6.33333L2.94996 2.475C3.73329 1.125 4.81662 0.375 5.99996 0.375C7.18329 0.375 8.26662 1.125 9.04996 2.48333L11.275 6.34167C12.0583 7.7 12.1666 9.01667 11.575 10.0417C10.9833 11.0583 9.79162 11.625 8.22496 11.625ZM5.99996 1.625C5.28329 1.625 4.58329 2.15 4.03329 3.10833L1.80829 6.96667C1.25829 7.925 1.14996 8.79167 1.50829 9.41667C1.86662 10.0417 2.67496 10.3833 3.77496 10.3833H8.22496C9.32496 10.3833 10.1333 10.0417 10.4916 9.41667C10.85 8.79167 10.7416 7.925 10.1916 6.96667L7.96662 3.10833C7.41662 2.15 6.71662 1.625 5.99996 1.625Z",
    fill: "#5D6373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.b900db1ecd38c4f9fbfcf05092d77af3.svg";
export { ForwardRef as ReactComponent };